/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AreaResponse } from '../../models/area-response';
import { AreaUpdateRequest } from '../../models/area-update-request';

export interface UpdateArea$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: AreaUpdateRequest
}

export function updateArea(http: HttpClient, rootUrl: string, params: UpdateArea$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaResponse>> {
  const rb = new RequestBuilder(rootUrl, updateArea.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AreaResponse>;
    })
  );
}

updateArea.PATH = '/api/v1/areas/{id}';
